// modules
export const MODULES_REQUEST_STATUS = "MODULES_REQUEST_STATUS";
export const MODULES_SET_LIST = "MODULES_SET_LIST";
export const MODULES_SET_ITEM = "MODULES_SET_ITEM";
export const MODULES_ITEM_REQUEST_STATUS = "MODULES_ITEM_REQUEST_STATUS";

// courses
export const CHANGE_LIST_LOADING = "CHANGE_LIST_LOADING";
export const SET_LIST = "SET_LIST";
export const GET_COURSE_ITEM_LOADING = "GET_COURSE_ITEM_LOADING";
export const SET_LIST_LENGTH = "SET_LIST_LENGTH";
export const CHANGE_SKIP = "CHANGE_SKIP";
export const COURSES_NEW_REQUEST_STATUS = "COURSES_NEW_REQUEST_STATUS";
export const COURSES_NEW_SET_LIST = "COURSES_NEW_SET_LIST";
export const CHANGE_CATEGORIES_LOADING = "CHANGE_CATEGORIES_LOADING";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const CHANGE_CATEGORY = "CHANGE_CATEGORY";
export const CHANGE_SORT = "CHANGE_SORT";
export const SET_COMPONENTS = "SET_COMPONENTS";
export const CHANGE_SEARCH_LOADING = "CHANGE_SEARCH_LOADING";
export const SET_SEARCH = "SET_SEARCH";
export const SET_SEARCH_HISTORY = "SET_SEARCH_HISTORY";

// timetable
export const GET_TIMETABLE_LOADING = "GET_TIMETABLE_LOADING";
export const SET_TIMETABLE = "SET_TIMETABLE";

export const CHANGE_POPUP_TRAILER = "CHANGE_POPUP_TRAILER";

export const CHANGE_LOADING = "CHANGE_LOADING";
export const SET_CURRENT_ITEM = "SET_CURRENT_ITEM";
export const SET_MODULE = "SET_MODULE";

// materials
export const MATERIALS_CHANGE_SKIP = "MATERIALS_CHANGE_SKIP";
export const MATERIALS_ITEM_REQUEST_STATUS = "MATERIALS_ITEM_REQUEST_STATUS";
export const MATERIALS_REQUEST_STATUS = "MATERIALS_REQUEST_STATUS";
export const MATERIALS_SET_ITEM = "MATERIALS_SET_ITEM";
export const MATERIALS_SET_LIST = "MATERIALS_SET_LIST";
export const MATERIALS_SET_LIST_LENGTH = "MATERIALS_SET_LIST_LENGTH";

// events
export const EVENTS_CHANGE_SKIP = "EVENTS_CHANGE_SKIP";
export const EVENTS_ITEM_REQUEST_STATUS = "EVENTS_ITEM_REQUEST_STATUS";
export const EVENTS_REQUEST_STATUS = "EVENTS_REQUEST_STATUS";
export const EVENTS_SET_ITEM = "EVENTS_SET_ITEM";
export const EVENTS_SET_LIST = "EVENTS_SET_LIST";
export const EVENTS_SET_LIST_LENGTH = "EVENTS_SET_LIST_LENGTH";

// events
export const STREAMS_CHANGE_SKIP = "STREAMS_CHANGE_SKIP";
export const STREAMS_ITEM_REQUEST_STATUS = "STREAMS_ITEM_REQUEST_STATUS";
export const STREAMS_REQUEST_STATUS = "STREAMS_REQUEST_STATUS";
export const STREAMS_SET_ITEM = "STREAMS_SET_ITEM";
export const STREAMS_SET_LIST = "STREAMS_SET_LIST";
export const STREAMS_SET_LIST_LENGTH = "STREAMS_SET_LIST_LENGTH";

// main
export const SET_ITEM = "SET_ITEM";
export const CHANGE_STEP = "CHANGE_STEP";
export const CHANGE_HOMEWORK_HEADER = "CHANGE_HOMEWORK_HEADER";
export const RESET = "RESET";
export const CHANGE_ANSWER_LOADING = "CHANGE_ANSWER_LOADING";
export const REPLACE_ANSWER_ITEM = "REPLACE_ANSWER_ITEM";
// lesson
export const SET_DATA_PROGRESS_LESSON = "SET_DATA_PROGRESS_LESSON";
export const CHANGE_PROGRESS_LOADING = "CHANGE_PROGRESS_LOADING";
export const INCREMENT_PROGRESS_LESSON = "INCREMENT_PROGRESS_LESSON";
export const SET_LESSON_RATE = "SET_LESSON_RATE";

// home-work
export const CHANGE_FROM_ROUTE_INFO = "CHANGE_FROM_ROUTE_INFO";
export const SET_COMMENT = "SET_COMMENT";

export const CHANGE_HEADER = "CHANGE_HEADER";
export const CHANGE_LOADING_REPORT = "CHANGE_LOADING_REPORT";
export const CHANGE_LOADING_TEST = "CHANGE_LOADING_TEST";
export const CHANGE_POPUP_CANCEL_TEST = "CHANGE_POPUP_CANCEL_TEST";
export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION";
export const SET_REPORT_RESULT = "SET_REPORT_RESULT";
export const CHANGE_FILTER = "CHANGE_FILTER";
export const SET_RATE = "SET_RATE";

//widgets
export const STUDENTS_SET_LIST = "STUDENTS_SET_LIST";
export const SYUDENTS_REQUEST_STATUS = "SYUDENTS_REQUEST_STATUS";
export const STUDENTS_SET_ALL_LIST = "STUDENTS_SET_ALL_LIST";

//feedback
export const SEND_FEEDBACK_FORM_LOADING = "SEND_FEEDBACK_FORM_LOADING";
export const SENT_FEEDBACK_FORM = "SENT_FEEDBACK_FORM";
export const GET_FEEDBACK_FORM_LOADING = "GET_FEEDBACK_FORM_LOADING";
export const SET_COURSE_FORMS = "SET_COURSE_FORMS";
export const SET_FEEDBACK_MESSAGES = "SET_FEEDBACK_MESSAGES";
